function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useState } from "react";
import { InfoPanel } from "../components/info-panel";
import { Heading } from "../components/heading";
import JSONTree from "../components/json-tree";
import { List } from "../components/list";
import { SplitView, SplitViewCol } from "../components/split-view";
import { useAtomValue } from "jotai";
import { editorStateAtom } from "../state/editor-state";
import SearchBar from "../components/search-bar";
import Button from "../components/button";
export function valueRenderer(raw) {
  if (typeof (arguments.length <= 1 ? undefined : arguments[1]) === "function") {
    return "func";
  }
  return raw;
}
export function PluginState(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, null, "Plugin State"), /*#__PURE__*/React.createElement(JSONTree, {
    data: props.pluginState,
    valueRenderer: valueRenderer,
    sortObjectKeys: true
  }));
}

// TODO: replace isDimmed with useCallback once EditorStateContainer is decomposed
export default function PluginsTab() {
  var state = useAtomValue(editorStateAtom);
  if (!state) return null;
  var _useState = useState(state.plugins[0]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedPlugin = _useState2[0],
    setSelectedPlugin = _useState2[1];
  var _useState3 = useState(state.plugins),
    _useState4 = _slicedToArray(_useState3, 2),
    pluginsLocal = _useState4[0],
    setPluginsLocal = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    sortAsc = _useState6[0],
    setSortOrder = _useState6[1];
  var handleOnListItemClick = React.useCallback(function (_plugin) {
    return setSelectedPlugin(_plugin);
  }, []);
  var selectedPluginState = selectedPlugin.getState(state);
  var handleSearch = useCallback(function (input) {
    var filteredPlugins = state.plugins.filter(function (plugin) {
      return plugin.key.toLowerCase().includes(input.toLowerCase());
    });
    setPluginsLocal(filteredPlugins);
  }, [state.plugins]);
  var handleClickSort = function handleClickSort() {
    setSortOrder(!sortAsc);
  };
  var handleSortAsc = function handleSortAsc(plugins) {
    return _toConsumableArray(plugins).sort(function (a, b) {
      if (a.key < b.key) {
        return -1;
      }
      if (a.key > b.key) {
        return 1;
      }
      return 0;
    });
  };
  var handleSortDes = function handleSortDes(plugins) {
    return _toConsumableArray(plugins).sort(function (a, b) {
      if (a.key < b.key) {
        return 1;
      }
      if (a.key > b.key) {
        return -1;
      }
      return 0;
    });
  };
  return /*#__PURE__*/React.createElement(SplitView, {
    testId: "__prosemirror_devtools_tabs_plugins__"
  }, /*#__PURE__*/React.createElement(SplitViewCol, {
    noPaddings: true
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      marginLeft: 6,
      marginRight: 6,
      marginBottom: 3,
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(SearchBar, {
    onSearch: handleSearch
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: handleClickSort
  }, "SORT ", sortAsc ? "DES" : "ASC")), /*#__PURE__*/React.createElement(List, {
    items: sortAsc ? handleSortAsc(pluginsLocal) : handleSortDes(pluginsLocal),
    getKey: function getKey(plugin) {
      return plugin.key;
    },
    title: function title(plugin) {
      return plugin.key;
    },
    isDimmed: function isDimmed(plugin) {
      return !plugin.getState(state);
    },
    onListItemClick: handleOnListItemClick
  })), /*#__PURE__*/React.createElement(SplitViewCol, {
    grow: true,
    sep: true
  }, selectedPluginState ? /*#__PURE__*/React.createElement(PluginState, {
    pluginState: selectedPluginState
  }) : /*#__PURE__*/React.createElement(InfoPanel, null, "Plugin doesn't have any state")));
}